// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"05c6b40a","190":"d0ce40f8","284":"4c08da8f","453":"8701dc61","626":"235ae7d6","651":"a9cdb92f","726":"56c05ec2"}[chunkId] + ".chunk.js";
};